import { DatePipe } from '@angular/common';
import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import { OutlookTimelineEvent } from '@maximizer/outlook/shared/domain';
import {
  TimelineConnectionPipe,
  TimelineEventPipe,
} from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'maximizer-outlook-timeline-card',
  templateUrl: './timeline-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DatePipe,
    TimelineConnectionPipe,
    TimelineEventPipe,
    TranslatePipe,
    UI_PIPES,
  ],
})
export class OutlookTimelineCardComponent {
  readonly outlookStore = inject(OutlookStore);
  event = input.required<OutlookTimelineEvent>();

  private readonly MAX_COLLAPSED_TEXT_LENGTH = 108;
  private readonly MAX_COLLAPSED_LINE_BREAKS = 3;

  expanded = false;

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  isLongText(): boolean {
    const text = this.event()?.subject ?? this.event()?.description ?? '';
    return (
      text.length > this.MAX_COLLAPSED_TEXT_LENGTH ||
      (text.match(/\n/g) || []).length >= this.MAX_COLLAPSED_LINE_BREAKS
    );
  }
}
